module.exports = __webpack_public_path__ + "img/map_1791458179490_12200.facb8f27.jpg";